import { Router } from "@reach/router";
import _map from 'lodash/map';
import React, { Component } from 'react';
import "./App.scss";
import { menu } from './config';
import { inViewService } from './services/InViewService';
import { analyticsService } from "./services/AnalyticsService";

const ScrollToTop = ({ children, location }) => {
  React.useEffect(() => window.scrollTo(0, 0), [location.pathname])
  return children;
}

export class App extends Component {
  list = null
  containerLayer = null;
  lineLayer = null;

  componentDidMount() {
    inViewService.createScrollListener();
  }

  createRoute(page, isDefault) {
    const Component = page.component;
    // const Container = () => <Component color={page.color} nextUrl={page.nextUrl} backUrl={page.backUrl} />;
    return <RouteContainer Component={Component} path={page.url != null ? page.url : page.id} key={page.id} default={isDefault} page={page} />
  }

  render() {
    const routes = _map(menu, page => this.createRoute(page));
    routes.push(this.createRoute(menu[0], true));
    return (
      <div className="App">
        <content className="App-content" ref="content">
          <Router primary={false}>
            <ScrollToTop path="/">
              {routes}
            </ScrollToTop>
          </Router>
        </content>
      </div>
    )
  }
}

class RouteContainer extends Component {
  componentDidMount() {
    analyticsService.pageView(this.props.location.pathname);
  }

  render() {
    const { Component, page, path, isDefault } = this.props;
    return <Component color={page.color} nextUrl={page.nextUrl} backUrl={page.backUrl} {...path} default={isDefault ? true : null} />;
  }
}
